import type { Category } from './context';
import type { ApiImage } from './image';
import type { Price, PriceTier } from './price';

export interface OfferAttribute {
    label: string | null;
    value: string;
}

export interface OfferAttributes {
    common: OfferAttribute[];
    ingredients: OfferAttribute[];
}

export interface RatingDistribution {
    1: number;
    2: number;
    3: number;
    4: number;
    5: number;
}

export interface Rating {
    average: number | null;
    count: number;
    distribution: RatingDistribution;
}

export interface QnaItem {
    question: string;
    answer: string;
}

export enum OfferStatus {
    ACTIVE = 'active',
    ENDING = 'ending',
    OUT_OF_STOCK = 'out_of_stock',
}

export interface Offer {
    id: number;
    slug: string | null;
    sku: string;
    status: OfferStatus;
    name: string;
    description: string | null;
    meta_description: string | null;
    price: Price;
    old_price: Price | null;
    price_expires_at: string | null;
    card_border_color: string | null;
    price_tiers: PriceTier[];
    images: ApiImage[];
    main_image: ApiImage;
    category: Category;
    attributes: OfferAttributes;
    qna: QnaItem[];
    tags: string[];
    rating: Rating;
}
